<template>
    <main-container>
        <div class="wrong__box">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="ionicon"
                viewBox="0 0 512 512"
            >
                <title>Alert Circle</title>
                <path
                    d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                    fill="none"
                    stroke="#cc3a3a"
                    stroke-miterlimit="10"
                    stroke-width="32"
                />
                <path
                    d="M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z"
                    fill="none"
                    stroke="#cc3a3a"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                />
                <path
                    d="M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z"
                    fill="#cc3a3a"
                />
            </svg>

            <h4>
                Оой! Что-то пошло не так.
            </h4>

            <a href="">
                Обновить
            </a>
        </div>
    </main-container>
</template>

<script>
import MainContainer from "./MainContainer.vue";

export default {
    components: { MainContainer }
};
</script>

<style lang="scss" scoped>
.wrong__box {
    min-height: 60vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    svg {
        max-width: 180px;
        width: 75%;
    }

    h4 {
        font-family: Acrom-Medium, sans-serif;
        margin: 20px 0;
        color: #cc3a3a;
    }

    a {
        font-family: Acrom-Medium, sans-serif;
        display: flex;
        align-items: center;

        margin-top: 20px;
        padding: 10px 20px;

        border-radius: 3px;
        background-color: #cc3a3a;
        color: #ffffff;
        transition: all 0.2s;

        &:hover {
            text-decoration: none;
            transform: translateY(-2px);
        }
    }
}
</style>
